<template>
    <bottom-sheet v-model="shows" fullscreen persistent v-bind="{ title }" hide-foot>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <view-wrap :value="form" :key="key" />
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { initEmploymentForm } from "@/assets/variables";
import { mapMutations, mapState } from "vuex";

import BottomSheet from "@/components/console/dumb/bottom-sheet.vue";
import ViewWrap from "./view/view-wrap.vue";

export default {
    components: {
        BottomSheet,
        ViewWrap,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        ...mapState("employment/form", ["form", "loading"]),
        ...mapState("employment/form/page", ["key"]),

        title() {
            let title = "계약서 양식 보기";
            return title;
        },
    },
    methods: {
        ...mapMutations("employment/form", ["setForm", "setLoading"]),
        async init() {
            if (this.loading) return;
            else this.setLoading(true);
            try {
                let { form } = await api.console.employment.forms.get({ _id: this.value._id });
                this.setForm(initEmploymentForm(form));
                this.$store.commit("employment/form/page/increaseKey");
            } finally {
                this.setLoading(false);
            }
        },
        exit() {
            this.shows = false;
        },
    },
    watch: {
        value() {
            if (this.shows) this.init();
            else this.$store.dispatch("employment/form/reset");
        },
        shows() {
            if (this.shows) this.init();
            else this.$store.dispatch("employment/form/reset");
        },
    },
};
</script>

<style lang="scss" scoped></style>
